import { getAdDimensions } from './imaSdkUtils';
import { VideoPlayer } from './VideoPlayer';
import { VideoPlayerWithControls } from './VideoPlayerWithControls';

type PreviewVideoProps = {
  adMarkup: string;
  onClose: () => void;
  showControls?: boolean;
};

export function PreviewVideo({ adMarkup, onClose, showControls = false }: PreviewVideoProps) {
  const [width, height] = getAdDimensions();

  if (showControls) {
    return <VideoPlayerWithControls adMarkup={adMarkup} onClose={onClose} width={width} height={height} />;
  }

  return <VideoPlayer adMarkup={adMarkup} onClose={onClose} width={width} height={height} />;
}
